import { Paper, Button, Typography, Box } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  NextSliderArrow,
  PrevSliderArrow,
} from "../../../components/SliderArrow";
import { Bedtime, LightMode } from "@mui/icons-material";

const setting = {
  dots: false,
  centerMode: true,
  centerPadding: "400px",
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  pauseOnHover: true,
  prevArrow: <PrevSliderArrow />,
  nextArrow: <NextSliderArrow />,
};

export const BannerSection = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      position="relative"
      sx={
        {
          // "& .slick-slide > img": {
          //   // margin: "0 5px",
          //   height: "400px",
          // },
        }
      }
    >
      <Slider className="carousel-slider" {...setting}>
        {items.map((item, index) => {
          return <Project item={item} key={index} />;
        })}
      </Slider>

      <Box
        position="absolute"
        bottom={0}
        left={0}
        right={0}
        display="flex"
        justifyContent="end"
        px={5}
      >
        <Box
          color="white"
          bgcolor="rgba(0, 0, 0, 0.8)"
          sx={{
            "&:hover": {
              bgcolor: "black",
            },
          }}
          width="max-content"
          p={2}
          display="flex"
          flexDirection="column"
          alignItems="center"
          borderRadius={1}
        >
          <Box display="flex" alignItems="center">
            <Box display="flex" paddingRight={2} alignItems="end">
              <LightMode fontSize="small" />
              <Typography>Lunch</Typography>
            </Box>
            <Typography fontWeight="bold" variant="h6">
              21,780
            </Typography>
          </Box>

          <Box display="flex" alignItems="center">
            <Box display="flex" paddingRight={2} alignItems="end">
              <Bedtime fontSize="small" />
              <Typography>Lunch</Typography>
            </Box>
            <Typography fontWeight="bold" variant="h6">
              21,780
            </Typography>
          </Box>

          <Button
            variant="contained"
            sx={{ color: "white", py: 1, px: 8, marginTop: 1 }}
          >
            プランをみる
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

function Project({ item }: { item: number }) {
  return (
    <Paper
      elevation={0}
      sx={{
        overflow: "hidden",
        height: "400px",
      }}
    >
      <img
        className="bannerImg"
        width="100%"
        style={{ objectFit: "contain" }}
        src={`/images/store-detail/img${item}.jpg`}
        alt="Imgage"
      />
    </Paper>
  );
}

const items = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
